import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import residenceIdentificationPlateUpdateAction from './residenceIdentificationPlateUpdate.action.json' with { type: 'json' }
import { residenceIdentificationPlateObject } from '../residenceIdentificationPlateObject'

const residenceIdentificationPlateUpdateDefinition = defineAction({
  ...residenceIdentificationPlateUpdateAction,

  input: z.object({
    id: residenceIdentificationPlateObject.shape.id,
    manufacturedAt: dateOrIsoString().nullish(),
    deliveredAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default residenceIdentificationPlateUpdateDefinition
